// extracted by mini-css-extract-plugin
export default {"remove":"AppDetailIcon_remove__6hyM1"};